export default __webpack_public_path__ + "static/media/chevron-left.ea7ace88.svg";